import isIntersecting from "../utils/isIntersecting.util";
import gsap from "gsap";

export default class CountTo {
    private countTo: number | null;

    constructor(private root: HTMLElement) {
        this.countTo = this.root.dataset.countto ? parseInt(this.root.dataset.countto) : null;
    }

    public init = async () => {
        isIntersecting(this.root, this.count, "10px");
    };

    private count = () => {
        const { countTo } = this;

        if (countTo) {
            let currentValue = 0;

            const timeline = gsap.timeline({
                onUpdate: () => {
                    this.root.textContent = Math.round(currentValue).toString();
                },
            });

            timeline.fromTo(
                { value: 0 },
                {
                    value: countTo,
                    duration: 3,
                    ease: "power1.inOut",
                },
                {
                    onUpdate: () => {
                        currentValue = timeline.progress() * countTo;
                    },
                }
            );
        }
    };
}
